import React from "react";
 
export default function Discounts() {
    return (
        <>
            <div id="discounts_"></div>
            <div id="discounts">
            <div id="discountstitle">Акции и скидки</div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4"><img className="discount" src="../images/discount.png" />
                        <div className="discounttext">Пенсионерам скидка 30%</div>
                    </div>
                    <div className="col-sm-4"><img className="discount" src="../images/discount.png" />
                        <div className="discounttext">Пенсионерам скидка 30%</div>
                    </div>
                    <div className="col-sm-4"><img className="discount" src="../images/discount.png" />
                        <div className="discounttext">Пенсионерам скидка 30%</div>
                    </div>
                </div>
            </div>
        </div>

            </>
    )
}